import ControlledSelect from './ControlledSelect.jsx';
import { isRequiredSelect } from '@@viewHelpers/validations';

const ControlledResidenceCountry = ({
  form,
  countries = [],
  isDisplayed = true,
  isRequired = false,
  disabled = false,
  name,
  label,
  dataTestId
}) => {
  if (!isDisplayed) {
    return null;
  }

  return (
    <ControlledSelect
      name={name}
      label={label}
      form={form}
      options={countries}
      rules={isRequiredSelect(countries, isRequired)}
      isSearchable
      disabled={disabled}
      data-testid={dataTestId}
    />
  );
};

export default ControlledResidenceCountry;
